import { render, staticRenderFns } from "./arviointipyynto-form.vue?vue&type=template&id=041ddb28&"
import script from "./arviointipyynto-form.vue?vue&type=script&lang=ts&"
export * from "./arviointipyynto-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports